import React, { useState } from 'react';
import { useWallet } from '../../contexts/WalletContext';
import WalletSelector from '../WalletSelector';
import './Step1WalletConnection.css';

const Step1WalletConnection: React.FC = () => {
  const { isConnected, account, connectWalletWithProvider, connectFreighter, loading, error } = useWallet();
  const [isWalletSelectorOpen, setIsWalletSelectorOpen] = useState(false);

  const handleWalletAction = () => {
    setIsWalletSelectorOpen(true);
  };

  const handleWalletSelect = async (provider: any, providerName: string) => {
    try {
      if (providerName === 'Freighter' || provider?.__stellar) {
        await connectFreighter();
      } else {
        await connectWalletWithProvider(provider, providerName);
      }
      setIsWalletSelectorOpen(false);
    } catch (err) {
      console.error('Failed to connect with selected provider:', err);
      // Keep modal open on error so user can try again
    }
  };

  return (
    <div className="wizard-step step1-wallet">
      <h2 className="wizard-step-title">Welcome to Trustline Onboarding</h2>
      <p className="wizard-step-description">
        This wizard will guide you through the process of configuring protection policies for your smart contract methods. 
        You'll register your contract information, create custom protection policies, and map them to specific 
        contract methods that require Trustline protection.
      </p>

      <div className="step1-prerequisite-notice">
        <div className="step1-prerequisite-icon">i</div>
        <div className="step1-prerequisite-content">
          <div className="step1-prerequisite-title">Prerequisite Required</div>
          <p className="step1-prerequisite-text">
            Before using this wizard, you must have already integrated Trustline into your smart contract and deployed it to your target network. This wizard configures protection policies for your deployed contract.
          </p>
          <p className="step1-prerequisite-action">
            If you haven't integrated Trustline yet, please visit{' '}
            <a href="https://dev.trustline.id" target="_blank" rel="noopener noreferrer" className="step1-prerequisite-link">
              dev.trustline.id
            </a>
            {' '}to get started with the integration.
          </p>
        </div>
      </div>

      <p className="wizard-step-description">
        Connect your wallet to begin the Trustline onboarding process. 
        Your wallet will be used for address retrieval and message signing.
      </p>

      {!isConnected ? (
        <div className="step1-connect-section">
          <button
            onClick={handleWalletAction}
            disabled={loading}
            className="step1-connect-btn"
          >
            {loading ? 'Connecting...' : 'Connect Wallet'}
          </button>
          {error && <div className="wizard-error">{error}</div>}
        </div>
      ) : (
        <div className="step1-connected-section">
          <div className="step1-success-icon">✓</div>
          <h3>Wallet Connected</h3>
          <p className="step1-address">{account}</p>
          <p className="step1-success-message">
            Your wallet is connected. You can proceed to the next step.
          </p>
        </div>
      )}

      <WalletSelector
        isOpen={isWalletSelectorOpen}
        onClose={() => setIsWalletSelectorOpen(false)}
        onSelectWallet={handleWalletSelect}
      />
    </div>
  );
};

export default Step1WalletConnection;

